
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    // Solo guardar scrollY si el drawer NO estaba ya abierto (evita pisar con 0 al reabrir tras reco-ATC)
    if (!document.body.classList.contains('cart-drawer-open')) {
      this._savedScrollY = window.scrollY;
    }
    // Scroll-lock móvil: custom.css aplica position:fixed+height:100% al body cuando tiene
    // .overflow-hidden. Si NO ponemos top:-scrollY, el body queda en y=0 y la PDP detrás se
    // renderiza desde su top (perdiendo la posición scrolleada). El override CSS en
    // cart-drawer.liquid añade height:auto para que el body abarque la PDP completa, y este
    // top negativo desplaza el body para mostrar la zona donde estaba el usuario.
    document.body.style.top = '-' + (this._savedScrollY || 0) + 'px';
    document.body.classList.add('overflow-hidden');
    document.documentElement.classList.add('overflow-hidden');
    document.body.classList.add('cart-drawer-open');
    try { (window._klOnsite = window._klOnsite || []).push(['closeForms']); } catch(e) {}
  }

  close() {
    this.classList.remove('active');
    // FIX PARÓN v3: limpiar cd-skip-anim al cerrar para que la PRÓXIMA apertura del drawer
    // permita la animación cgb-item-in en .cart-item (cascada visible al abrir desde el icono).
    this.classList.remove('cd-skip-anim');
    removeTrapFocus(this.activeElement);
    // Limpieza agresiva de TODO estado de scroll-lock (defensivo contra Klaviyo, reco-ATC race, etc)
    document.body.classList.remove('overflow-hidden', 'cart-drawer-open', 'klaviyo-prevent-body-scrolling');
    document.documentElement.classList.remove('overflow-hidden');
    document.body.style.top = '';
    document.body.style.position = '';
    document.body.style.overflow = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.documentElement.style.top = '';
    document.documentElement.style.position = '';
    document.documentElement.style.overflow = '';
    var y = this._savedScrollY;
    this._savedScrollY = null;
    // Sin position:fixed en open(), no hace falta restaurar scrollY (la página nunca se desplazó)
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

   setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // Línea borrada para que no se abra solo
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

// Bloquea popups de Klaviyo mientras el drawer del carrito esté abierto
window.addEventListener('klaviyoForms', function(e) {
  if (e && e.detail && e.detail.type === 'open' && document.body.classList.contains('cart-drawer-open')) {
    try { (window._klOnsite = window._klOnsite || []).push(['closeForms']); } catch(err) {}
  }
});

class CartDrawerItems extends CartItems {
  // FIX PARÓN: NO suscribirse a cartUpdate. product-form.js ya hace su propio swap del HTML
  // al recibir res.body.sections — sin este override CartItems.connectedCallback dispara un
  // segundo fetch /cart?section_id=cart-drawer + replaceWith que provoca un flash visual ~400ms
  // después del swap principal.
  connectedCallback() {}
  disconnectedCallback() {}

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
